export enum TransactionStatus {
  Success = 1,
  UnSuccess = 2,
}

export const TransactionStatusLabel = new Map<TransactionStatus, string>([
  [TransactionStatus.Success, "موفق"],
  [TransactionStatus.UnSuccess, "ناموفق"],
]);
